/**
 * RegisterServiceSlice.js
 * 
 * This file contains the Redux slice for managing the state related to B+ Enrollment 
 * This file manages B+ enrollment service opted from other pages other than EcoPro dashboard.
*/

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  data: null,
  error: null,
  success: false
}

const RegisterServiceSlice = createSlice({
  name: 'enrollmentRegisterService',
  initialState,
  reducers: {
    EnrollmentRegisterServiceInit(state) {
      state.loading = true;
      state.error = null;
      state.success = false
    },
    EnrollmentRegisterServiceSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.success = true
    },
    EnrollmentRegisterServiceFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
      state.success = false
    },
    EnrollmentRegisterServiceReset: () => initialState
  },
});

export const { 
  EnrollmentRegisterServiceInit, 
  EnrollmentRegisterServiceSuccess, 
  EnrollmentRegisterServiceFailure,
  EnrollmentRegisterServiceReset
} = RegisterServiceSlice.actions;

export default RegisterServiceSlice.reducer;
